import { useState, useEffect, useRef } from "react";
import BrandCard from "./BrandCard";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ChevronLeftOutlinedIcon from "@material-ui/icons/ChevronLeftOutlined";
import ChevronRightOutlinedIcon from "@material-ui/icons/ChevronRightOutlined";

function HomeBrand(props) {
  const { t } = useTranslation();
  const history = useNavigate();
  const { langs, isLocal } = props;
  const [mainL, setMainL] = useState("en-US");
  const theme = JSON.parse(localStorage.getItem("machine"))?.themeColor;
  let rows = theme?.b_row;

  const [showL, setShowL] = useState(true);
  const [showR, setShowR] = useState(true);

  const ref = useRef(null);

  useEffect(() => {
    const mycoockie = Cookies.get("i18next");
    if (mycoockie === "fr") {
      setMainL("fr-CA");
    } else if (mycoockie === "es") {
      setMainL("es-US");
    }
  }, []);

  let brands = JSON.parse(localStorage.getItem("brand"))
    ? JSON.parse(localStorage.getItem("brand"))
    : [];

  const scroll = (scrollOffset) => {
    ref.current.scrollLeft += scrollOffset;
  };

  const runState = () => {
    if (ref) {
      setShowL(ref.current.scrollLeft === 0);
      setShowR(
        !(
          ref.current.scrollLeft <
          ref.current.scrollWidth - ref.current.clientWidth
        )
      );
    }
  };

  const handleScroll = () => {
    runState();
  };

  useEffect(() => {
    runState();
  }, []);

  useEffect(() => {
    if (ref) {
      ref?.current?.addEventListener("scroll", handleScroll, { passive: true });

      return () => {
        ref?.current?.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  // console.log('theme', theme);

  // if (rows?.length > 0) {
  //   const index = rows * 3;
  //   if (brands?.length >= index) {
  //     brands = brands.slice(0, index);
  //   }
  // }

  // const result = brands.map((prod) => {
  //   // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;
  //   const url = isLocal
  //     ? `${process.env.REACT_APP_LOCAL_API}/pictures/brand/${prod.picture}`
  //     : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;
  //   // const logo = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.logo}/${prod.referTo}`;
  //   const logo = isLocal
  //     ? `${process.env.REACT_APP_LOCAL_API}/pictures/brand/${prod.logo}`
  //     : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.logo}/${prod.referTo}`;
  //   return <BrandCard key={prod._id} langs={langs} prod={prod} image={url} logo={logo} />;
  // });

  const goCatePage = (catename, cateID) => {
    history(`/machineUI/category/brand/${catename}/${cateID}`);
  };

  const result = brands.map((prod, i) => {
    const name =
      prod.name[langs] && prod.name[langs] !== ""
        ? prod.name[langs]
        : prod.name?.en;
    const url = isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/brand/${prod.picture}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;

    if (theme?.brand_image_button === "true") {
      return (
        <div className="home-cate-div" key={i}>
          <div
            className="home-cate-button home-cate-button-image d-flex align-items-center justify-content-center mr-3"
            style={{
              width: "234px",
              height: "130px",
            }}
            key={i}
            onClick={() => {
              localStorage.setItem("currentCate", JSON.stringify(prod));
              goCatePage(name, prod._id);
            }}
          >
            <img className="hundred-percent" src={url} />
          </div>
        </div>
      );
    } else
      return (
        <div className="home-cate-div" key={i}>
          <div
            className="home-cate-button d-flex align-items-center justify-content-center mr-3"
            key={i}
            onClick={() => {
              localStorage.setItem("currentCate", JSON.stringify(prod));
              goCatePage(name, prod._id);
            }}
          >
            <span className="home-cate-button-text">{name}</span>
          </div>
        </div>
      );
  });

  const allBrandPage = () => {
    history(`/machineUI/category/brand/allBrand/all`);
  };

  let row1 = [];
  let row2 = [];
  let row3 = [];

  if (theme?.c_column === "1") {
    if (result.length < 6) {
      for (let i = 1; i <= result.length; i++) {
        if (i < 4) {
          row1.push(result[i - 1]);
        } else {
          row2.push(result[i - 1]);
        }
      }
    } else {
      for (let i = 1; i <= result.length; i++) {
        if (i % 2 === 1) {
          row1.push(result[i - 1]);
        }
        if (i % 2 === 0) {
          row2.push(result[i - 1]);
        }
      }
    }
  } else {
    for (let i = 1; i <= result.length; i++) {
      if (i < 4) {
        row1.push(result[i - 1]);
      } else if (i < 7) {
        row2.push(result[i - 1]);
      } else if (i < 10) {
        row3.push(result[i - 1]);
      } else {
        if (i % 3 === 1) {
          row1.push(result[i - 1]);
        }
        if (i % 3 === 2) {
          row2.push(result[i - 1]);
        }
        if (i % 3 === 0) {
          row3.push(result[i - 1]);
        }
      }
    }
  }

  return (
    // <div className="homeProduct" style={{ marginBottom: '30px' }}>
    //   <h1 className="homeProductText">{t(`Shop By Brand`)}</h1>
    //   {/* <div className="home-product-container d-flex">{products}</div> */}
    //   <div className="home-brand-div">{result}</div>
    //   <div className="view-more-button " onClick={allBrandPage}>
    //     {t('VIEW MORE')}
    //   </div>
    // </div>

    <div className="homeProduct">
      <h1 className="homeProductText mt-5 mb-5">{t(`Shop By Brand`)}</h1>
      {/* <div className="home-product-container d-flex">{products}</div> */}
      {/* <div className="home-category-div">{result}</div> */}
      <div className="d-flex align-items-center">
        <div>
          <div style={{ width: "50px" }}>
            <ChevronLeftOutlinedIcon
              hidden={showL}
              className="home-page-arrow-icon"
              onClick={() => scroll(-100)}
            />
          </div>
        </div>
        <div className="cate-container ml-2 mr-2 pl-3" ref={ref}>
          <div
            className={
              theme?.brand_image_button ? `category-row mb-3` : `category-row`
            }
          >
            {row1}
          </div>
          <div
            className={
              theme?.brand_image_button ? `category-row mb-3` : `category-row`
            }
          >
            {row2}
          </div>
          {row3.length > 0 && (
            <div
              className={
                theme?.brand_image_button ? `category-row mb-3` : `category-row`
              }
            >
              {row3}
            </div>
          )}
        </div>
        <div>
          <div style={{ width: "50px" }}>
            <ChevronRightOutlinedIcon
              hidden={showR}
              className="home-page-arrow-icon"
              onClick={() => scroll(100)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default HomeBrand;
